import { useState, useEffect, Fragment } from "react";
import Backdrop from "@mui/material/Backdrop";
import Button from "@mui/material/Button";
import Paper from "@mui/material/Paper";
import { useNavigate } from "react-router-dom";
import { copyUserLink, copyNicheLink } from "utils/share";
import { isAuthenticated } from "services/Auth";
import { routes } from "routes";
import classes from "./Styles.module.css";
import EditIcon from "../../components/icons/edit_icon.svg?react";
import ShareIcon from "../../components/icons/share_icon_red.svg?react";
import ManageIcon from "../../components/icons/manage_icon.svg?react";
import colors from "../../theme/themeConstants";

interface IProps {
  isOpen: boolean;
  togglePopup: () => void;
  userName?: string;
  myself?: boolean;
  nicheName?: string;
  onNicheEditOpen?: () => void;
}
// TODO: refactor ProfileMenuPopup
const ProfileMenuPopup = (props: IProps) => {
  const { isOpen, togglePopup, userName, myself, nicheName, onNicheEditOpen } = props;
  const navigate = useNavigate();
  const [isAuth, setIsAuth] = useState(false);
  const isAllowManage = myself && isAuth;

  useEffect(() => {
    (async () => {
      setIsAuth(await isAuthenticated());
    })();
  });

  const handleStopPropagation = (event: React.MouseEvent) => {
    event.stopPropagation();
  };

  const handleClose = (event: React.MouseEvent) => {
    handleStopPropagation(event);
    togglePopup();
  };

  const handleCopy = async () => {
    if (userName) {
      await copyUserLink(userName);
    }

    if (nicheName) {
      await copyNicheLink(nicheName);
    }

    togglePopup();
  };

  const handleManage = () => {
    navigate(routes.manageProfile());
  };

  const handleEdit = () => {
    if (userName) {
      navigate(routes.accountSettings());
    }

    if (onNicheEditOpen) {
      onNicheEditOpen();
      togglePopup();
    }
  };

  const ACTIONS = [
    ...(isAllowManage ? [{ text: "Edit", icon: EditIcon, onClick: handleEdit }] : []),
    { text: "Share", icon: ShareIcon, onClick: handleCopy },
    ...(isAllowManage && !nicheName ? [{ text: "Manage", icon: ManageIcon, onClick: handleManage }] : [])
  ];

  return (
    <Fragment>
      <Backdrop
        open={isOpen}
        sx={{
          zIndex: "var(--popupZ)"
        }}
        onClick={handleClose}
        id={"popupOpen"}
      >
        <Paper
          onClick={handleStopPropagation}
          sx={{
            width: "100%",
            height: "auto",
            position: "fixed",
            bottom: isOpen ? "0" : "-15rem",
            transition: "bottom 300ms cubic-bezier(0, 0, 1, 1) 0ms",
            margin: "0 1rem",
            borderTopRightRadius: "24px",
            borderTopLeftRadius: "24px",
            padding: "2rem 1rem",
            paddingTop: "1rem",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            gap: "1rem",
          }}
        >
          <div
            className={classes.handler}
            onClick={togglePopup}
          />
          <div className={classes.actions}>
            {ACTIONS.map(({ text, onClick, icon: Icon }) => (
              <Button
                key={text}
                className={classes.actionButton}
                aria-label={`${text} button`}
                sx={{
                  backgroundColor: colors.lightGrayPaperBackground,
                  color: colors.textDark,
                  "svg": {
                    height: 22,
                    width: "auto"
                  }
                }}
                onClick={onClick}
              >
                <Icon />
                <span>{text}</span>
              </Button>
            ))}
          </div>
        </Paper>
      </Backdrop>
    </Fragment>
  );
};

export default ProfileMenuPopup;
